/*
 * @Author: Long
 * @Date: 2021-05-09 17:43:42
 * @LastEditors: Long
 * @LastEditTime: 2022-03-08 15:11:30
 */
const service = require('@/assets/js/request')
const env = process.env

class literature {
  /**
   * 获取文献列表
   */
  static getWebArticleList (target) {
    service.request({
      method: 'POST',
      url: 'getWebArticleList',
      params: {
        limit: target.limit,
        page: target.page,
        isHot: 1
      }
    }).then(res => {
      if (res.code === '2001') {
        for (let i = 0; i < res.data.list.length; i++) {
          var item = res.data.list[i]
          if (item.cover_img !== '') {
            item.cover_img = env.IMG_URL + item.cover_img
          }
        }
        target.list = res.data.list
        target.total = res.data.count
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default literature



// WEBPACK FOOTER //
// ./src/components/index/literature/literature.js